import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "sidebar";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
